module.exports = __webpack_public_path__ + "static/media/MarketingIconBlack.830f1d2f.svg";